var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"container--columns"},[_c('div',{class:{
        'container--columns-template-width-30': _vm.ratio === '30/70',
        'container--columns-template-width-70': _vm.ratio === '70/30',
        'container--columns-template-width-50': _vm.ratio === '50/50',
      }},[_vm._t("left")],2),_vm._v(" "),_c('div',{class:{
        'container--columns-template-width-70': _vm.ratio === '30/70',
        'container--columns-template-width-30': _vm.ratio === '70/30',
        'container--columns-template-width-50': _vm.ratio === '50/50',
      }},[_vm._t("right")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }